<template lang="pug">
feathers-vuex-find(service="bh-profile-templates" :query="dataQuery" :fetch-query="fetchQuery" watch="query")
    v-card(slot-scope="{ items: desserts, pagination: serverPagination, isFindPending }")
        v-card-title Profile Template Manager
            v-spacer
            //- v-text-field(v-model="searchUser" append-icon="mdi-magnify" label="Search" single-line hide-details)
            add-new-profile-template(@success="successMessage = true" @error="onError")
        v-data-table(
            :headers="headers"
            :loading="isFindPending"
            :items="isFindPending ? [] : desserts"
            :options.sync="pagination"
            :server-items-length="!serverPagination ? 0 : serverPagination.mostRecent.total"
            :footer-props="{ showCurrentPage: true, itemsPerPageOptions: [10, 15, 20, 25, 30] }"
            loading-text="Fetching Data..."
        )
            template(v-slot:item.name="{ item }")
                div(style="text-align: center;")
                    img(:src="item.image" height="50")
                div(style="text-align: center; font-weight: bold;") {{ item.name }}

            template(v-slot:item.action="{ item }")
                add-new-profile-template(@success="successMessage = true" @error="onError" :item="item")
                remove-profile-template(:item="item" @success="successMessage = true" @error="onError")

        v-snackbar(top v-model="successMessage" color="success") Successfully Saved!
        v-snackbar(top v-model="error.show" color="red") {{ error.message }}
</template>

<script>
import moment from 'moment';
// import FeaturedButton from './components/FeaturedButton.vue';
import AddNewProfileTemplate from './components/AddNewProfileTemplate.vue';
import RemoveProfileTemplate from './components/RemoveProfileTemplate.vue';

export default {
    data() {
        return {
            successMessage: false,
            error: {
                show: false,
                message: ''
            },
            searchUser: '',
            headers: [
                {
                    text: 'Name / Image',
                    align: 'start',
                    sortable: false,
                    value: 'name'
                },
                {
                    text: 'Type',
                    align: 'start',
                    sortable: false,
                    value: 'type'
                },
                {
                    text: 'Status',
                    align: 'start',
                    sortable: false,
                    value: 'status'
                },
                {
                    text: 'Date Added',
                    align: 'end',
                    sortable: false,
                    value: 'createdAt'
                },
                {
                    text: 'Action',
                    align: 'end',
                    sortable: false,
                    value: 'action'
                }
            ],
            pagination: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [ 'id' ],
                sortDesc: [ true ]
            },
            query: {},
        };
    },
    filters: {
        dateFormat(date) {
            if(date) {
                return moment(date).format('lll');
            }

            return 'n/a';
        },
        status(status) {
            switch(status) {
                case 0: return 'Inactive';
                case 1: return 'Active';
            }
        }
    },
    computed: {
        extendedQuery() {
            if(this.user) {
                return {
                    // id: { $nin: [this.user.id] }
                };
            }
            return null;
        },
        searchQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { title: { $like: `%${this.searchUser}%` } },
                    ]
                };
            }
            return null;
        },
        searchDataQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { title: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
                    ]
                };
            }
            return null;
        },
        sortingQuery() {
            if(this.pagination.sortBy.length !== 0) {
                const $sort = {};
                this.pagination.sortBy.map((item, index) => {
                    switch(item) {
                        case 'fullname':
                            $sort.fname = this.pagination.sortDesc[index] ? -1 : 1;
                            $sort.lname = this.pagination.sortDesc[index] ? -1 : 1;
                            break;
                        default:
                            $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                    }
                    
                });
                return { $sort };
            }
            return null;
        },
        dataQuery() {
            return {
                ...this.query,
                ...this.extendedQuery,
                ...this.searchDataQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            };
        },
        fetchQuery() {
            return Object.assign({}, {
                ...this.query,
                ...this.extendedQuery,
                // $populate: true
            }, {
                ...this.searchQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            });
        },
    },
    methods: {
        escapeRegex(string) {
            return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
        },
        onError(err) {
            this.error.show = true;
            this.error.message = err.message;
        },
    },
    components: {
        // FeaturedButton
        AddNewProfileTemplate,
        RemoveProfileTemplate
    }
}
</script>